import { tv } from "@pcln/horizon";
import { SEARCH_FORM_CARD_WIDTH_CLASS_NAMES } from "./SearchFormCard.constants.js";
const searchFormCard = tv({
    slots: {
        root: '@container max-w-full overflow-visible',
        header: 'flex flex-col gap-1 pb-3',
        content: 'w-full'
    },
    variants: {
        variant: {
            panel: {
                root: 'rounded-2xl border border-neutral-5 bg-neutral-1 p-4 shadow-xl'
            },
            inline: {
                root: 'bg-transparent p-0'
            }
        },
        width: {
            panel: {
                root: SEARCH_FORM_CARD_WIDTH_CLASS_NAMES.panel
            },
            drawer: {
                root: SEARCH_FORM_CARD_WIDTH_CLASS_NAMES.drawer
            },
            embedded: {
                root: SEARCH_FORM_CARD_WIDTH_CLASS_NAMES.embedded
            },
            page: {
                root: SEARCH_FORM_CARD_WIDTH_CLASS_NAMES.page
            },
            wide: {
                root: SEARCH_FORM_CARD_WIDTH_CLASS_NAMES.wide
            },
            full: {
                root: SEARCH_FORM_CARD_WIDTH_CLASS_NAMES.full
            }
        }
    },
    defaultVariants: {
        variant: 'panel',
        width: 'full'
    }
});
export { searchFormCard };
